import React, { Component } from 'react';
import { getPlan, CreatePay, partnerApi, partnerSubscription, getPartnerSubscriptions, checkAndsubscribeWiseConnect, getSpecialDiscount, getAddonList } from './../../../../API/FetchCall';
import SimpleReactValidator from 'simple-react-validator';
import { RAZORPAY_LIVE, RAZORPAY_TEST } from '../../../../constant.js';
import { Modal, ModalBody, ModalHeader, Row, Col, ModalFooter } from 'reactstrap';
/*
const bewisevalue = {

    plan_name:"BeWise Value",
    plan_base_price:12499, //12499
    plan_final_price:12499,
    plan_duration:12,
    plan_duration_period:'month(s)',
    plan_discount:0,
    plan_total_price:(12499-0),
    plan_sdesc:'',
    plan_modal:"bewisevalue"
}
*/
const bewisevalue = {

  plan_name:"BeWise Value",
  plan_base_price:12499, //12499
  plan_final_price:12499,
  plan_duration:12,
  plan_duration_period:'month(s)',
  plan_discount:0,
  plan_total_price:(12499-0),
  plan_sdesc:'',
  plan_modal:"bewisevalue"
}

const bewisemagic = {

  plan_name:"BeWise Magic",
  plan_base_price:19999,
  plan_final_price:19999,
  plan_duration:12,
  plan_duration_period:'month(s)',
  plan_discount:0,
  plan_total_price:(19999-0),
  plan_sdesc:'',
  plan_modal:"bewisemagic"
}


const bewisevalueaddon = {

  plan_name:"Addon - Branch",
  plan_base_price:6250,
  plan_final_price:6250,
  plan_duration:12,
  plan_duration_period:'month(s)',
  plan_discount:0,
  plan_total_price:(6250-0),
  plan_sdesc:'',
  plan_modal:"bewisevalueaddon"
}

const bewisemagicaddon = {

  plan_name:"Addon - Branch",
  plan_base_price:9999,
  plan_final_price:9999,
  plan_duration:12,
  plan_duration_period:'month(s)',
  plan_discount:0,
  plan_total_price:(9999-0),
  plan_sdesc:'',
  plan_modal:"bewisemagicaddon" //50% discount from 19999 baseprice
}

const wiseconnect = {

  plan_name:"WiseConnect",
  plan_base_price:699,
  plan_final_price:8388,
  plan_duration:12,
  plan_duration_period:'month(s)',
  plan_sdesc:'',
  plan_discount:8388,
  plan_total_price:(8388-8388),
  plan_modal:"wiseconnect"

}

const wiseconnectexclusive = {

  plan_name:"WiseConnect Exclusive",
  plan_base_price:1299,
  plan_final_price:7794,
  plan_duration:6,
  plan_duration_period:'month(s)',
  plan_sdesc:'',
  plan_discount:0,
  plan_total_price:(7794-0),
  plan_modal:"wiseconnectexclusive"
}

class UpgradeV1 extends Component {

  constructor(props) {
    super(props);
    this.state = {
      logged: localStorage.getItem("authentication"),
      auth_data: JSON.parse(localStorage.getItem("user_data")),
      chart_data: [],
      upgradeClicked:true,
      planselected:false,
      package_list: [],
      upgradeList: [], 
      subscriptionList:[],
      paymentsuccess:false,
      addonlist:[],
      plan:'',
      order_id:0,
      special_discount:0,
      special_discount_view:0,
      paymentresponse:[],
      pname: '', planselect: false, errors: [],
      basesubtotal: 0, subtotal: 0, discount_per: 0, discount_amount: 0, coupon_per: 0, chart_discount: 0, chart_discount_amount: 0,
      coupon_amount: 0, sgst_per: 0, cgst_per: 0, sgst_amount: 0, cgst_amount: 0, totalpayable: 0, totalselected: 0,
      partner_name: '', partner_email: '', partner_address: '', coupon_per_or: 0, coupon_amount_or: 0,
      coupon_applied: false
      // planlist: [], upgradeplanid: '', planid: 0, plan_price: '', discamt: '', originalprice: '',
      // curren_plname: '', new_plname: '', other_description: '', plan_period: '', plan_ndesc: '',
    }
    this.validator = new SimpleReactValidator();
    //this.getPlanList();
    //this.getChartData();
    //this.getCurrentPlanList();
    
    this.showForm = this.showForm.bind(this);
    this.openPopupPlanStandard = this.openPopupPlanStandard.bind(this);
    this.cancelPop1 = this.cancelPop1.bind(this);
    this.cancelPopAddon = this.cancelPopAddon.bind(this);
    this.cancelPopWc = this.cancelPopWc.bind(this);
    this.cancelPopBv = this.cancelPopBv.bind(this);
    this.cancelPopWcExcl = this.cancelPopWcExcl.bind(this);
    this.executeUpgradeList = this.executeUpgradeList.bind(this);
    this.handlePaySubmitDummy = this.handlePaySubmitDummy.bind(this);
    this.handlePaySubmit = this.handlePaySubmit.bind(this);
    this.getSubscriptions = this.getSubscriptions.bind(this);
    this.subscribeTrail = this.subscribeTrail.bind(this);
    this.getAddonList = this.getAddonList.bind(this);
    this.getSpecialDiscount = this.getSpecialDiscount.bind(this);

  }


  componentDidMount() {
    window.jQuery('.selectpicker').selectpicker('refresh');
    this.getcurrentPlan();
    this.getAddonList();
    this.getSpecialDiscount();
  }

  subscribeTrail = () =>{

    let insdata = JSON.stringify({
      user_type: this.state.auth_data.user_type,
      vendor_id: this.state.auth_data.login_id,
      code:this.state.code
    })

    checkAndsubscribeWiseConnect(insdata).then((response) => {
      if (response.status === 1) {
        this.setState({wc_success:true, wc_error:false, wc_success_message:response.message});   
      }
      else{
        this.setState({wc_error:true, wc_success:false, wc_error_message:response.message});
      }
    });
    
  }

  getSpecialDiscount = () => {
    let insdata = JSON.stringify({
      uid: this.state.auth_data.uid
    })
    getSpecialDiscount(insdata).then((response) => {
      if (response.status === 1) {
         this.setState({special_discount:response.special_discount_formatted});
      }
    });
  }  

  getAddonList = () => {
    let insdata = JSON.stringify({
      vendor_id: this.state.auth_data.login_id,
      url: 'getAddonList'
    })
    getAddonList(insdata).then((response) => {
      if (response.status === 1) {
         this.setState({addonlist:response.list});
      }
    });
  }  
 
  getcurrentPlan = () => {
    let insdata = JSON.stringify({
      user_type: this.state.auth_data.user_type,
      vendor_id: this.state.auth_data.login_id,
      url: 'getCurrentPlanV1'
    })
    partnerSubscription(insdata).then((response) => {
      if (response.status === 1) {
        let isupgraded = response.upgraded;

        if(isupgraded==1){

            this.getSubscriptions();

        }
        this.setState({upgraded:isupgraded});
        
      }
    });
  }

  getSubscriptions = () => {

    let insdata = JSON.stringify({
      vendor_id: this.state.auth_data.login_id,
    })
    getPartnerSubscriptions(insdata).then((response) => {
      if (response.status === 1) {
         this.setState({subscriptionList:response.list});
      }
      else{
        this.setState({subscriptionList:[]}); 
      }
    });

  }


  openPopupPlanStandard(){
    this.setState({openPopupPlanStandard:true});
  }

  openPlanPop = (modalid) => {
      if(modalid=='wiseconnect')
       this.setState({openPopupPlanWc:true});  

     if(modalid=='wiseconnectexclusive')
       this.setState({openPopupPlanWcExcl:true});  
     
     if(modalid=='bewisevalue')
      this.setState({openPopupPlanBv:true});  
      
      if(modalid=='bewisemagic')
      this.setState({openPopupPlanMg:true});  

     if(modalid=='bewisevalueaddon')
      this.setState({openPopupAddOn:true});  
                 
     if(modalid=='bewisemagicaddon')
     this.setState({openPopupAddOn:true});  
  }

  cancelPop1(){
    this.setState({openPopupPlanStandard:false});
  }

  cancelPopAddon(){
    this.setState({openPopupAddOn:false});  
  }
  cancelPopBv(){
    this.setState({openPopupPlanBv:false});
  }
  cancelPopWc(){
    this.setState({openPopupPlanWc:false});
  }

  cancelPopWcExcl(){
    this.setState({openPopupPlanWcExcl:false});
  }

  showForm(){

    this.setState({upgradeClicked:true});

  }

  executeUpgradeList(e){

        let keyselected = e.target.value;

        this.setState({planselected:true, planname:keyselected});

       
        if(keyselected=='bwvwc'){
            let pk = [];
            pk.push(bewisevalue, wiseconnect);

            let total = bewisevalue.plan_total_price+wiseconnect.plan_total_price;
            let discount_amount = total*this.state.special_discount;
            
            var discount_amount_view = new Intl.NumberFormat('en-IN', {
              style: 'currency',
              currency: 'INR'
            }).format(discount_amount);

            let discounted_total = total-(discount_amount);

            var discounted_total_view = new Intl.NumberFormat('en-IN', {
              style: 'currency',
              currency: 'INR'
            }).format(discounted_total);

            var subtotal_view = new Intl.NumberFormat('en-IN', {
              style: 'currency',
              currency: 'INR'
            }).format(total);

            this.setState({package_list:pk, 
                           plan_name: bewisevalue.plan_name +"+"+wiseconnect.plan_name,
                           special_discount_view:discount_amount_view,
                           subtotal:total, 
                           subtotal_view:subtotal_view,
                           total:discounted_total,  
                           total_view:discounted_total_view,  
                           totalpayable:discounted_total});

            //this.setState({package_list:pk, total: (bewisevalue.plan_total_price+wiseconnect.plan_total_price), subtotal:(bewisevalue.plan_total_price+wiseconnect.plan_total_price), totalpayable:(bewisevalue.plan_total_price+wiseconnect.plan_total_price)});
        }

        if(keyselected=='bwmwc'){
          let pk = [];
          pk.push(bewisemagic, wiseconnect);
          this.setState({package_list:pk,
               plan_name: bewisevalue.plan_name +"+"+wiseconnect.plan_name,
               total: (bewisemagic.plan_total_price+wiseconnect.plan_total_price), subtotal:(bewisemagic.plan_total_price+wiseconnect.plan_total_price), totalpayable:(bewisemagic.plan_total_price+wiseconnect.plan_total_price)});
      }

        if(keyselected=='wconly'){
          let pk = [];
            pk.push(wiseconnectexclusive);
            this.setState({package_list:pk,plan_name: wiseconnectexclusive.plan_name, subtotal:(wiseconnectexclusive.plan_total_price) , total:(wiseconnectexclusive.plan_total_price) ,totalpayable:(wiseconnectexclusive.plan_total_price)});
        }
        if(this.state.addonlist.length>0){

          if(keyselected=='bwv'){
            let pk = [];
            pk.push(bewisevalue);
            pk.push(bewisevalueaddon);

            let total = bewisevalue.plan_total_price+bewisevalueaddon.plan_total_price;
            let discount_amount = total*this.state.special_discount;
            
            var discount_amount_view = new Intl.NumberFormat('en-IN', {
              style: 'currency',
              currency: 'INR'
            }).format(discount_amount);

            let discounted_total = total-(discount_amount);

            var discounted_total_view = new Intl.NumberFormat('en-IN', {
              style: 'currency',
              currency: 'INR'
            }).format(discounted_total);

            var subtotal_view = new Intl.NumberFormat('en-IN', {
              style: 'currency',
              currency: 'INR'
            }).format(total);

            this.setState({order_id:this.state.addonlist[0].order_id, 
                           package_list:pk, 
                           plan_name: bewisevalue.plan_name +"+"+bewisevalueaddon.plan_name,
                           special_discount_view:discount_amount_view,
                           subtotal:total, 
                           subtotal_view:subtotal_view,
                           total:discounted_total,  
                           total_view:discounted_total_view,  
                           totalpayable:discounted_total});
          }


          if(keyselected=='bwvwc'){
            let pk = [];
            pk.push(bewisevalue, bewisevalueaddon, wiseconnect);

            let total = bewisevalue.plan_total_price+wiseconnect.plan_total_price+bewisevalueaddon.plan_total_price;
            let discount_amount = total*this.state.special_discount;
            var discount_amount_view = new Intl.NumberFormat('en-IN', {
              style: 'currency',
              currency: 'INR'
            }).format(discount_amount);

            let discounted_total = total-(discount_amount);

            var discounted_total_view = new Intl.NumberFormat('en-IN', {
              style: 'currency',
              currency: 'INR'
            }).format(discounted_total);

            var subtotal_view = new Intl.NumberFormat('en-IN', {
              style: 'currency',
              currency: 'INR'
            }).format(total);

            this.setState({order_id:this.state.addonlist[0].order_id, 
                           package_list:pk, 
                           plan_name: bewisevalue.plan_name +"+"+bewisemagicaddon.plan_name+"+"+wiseconnect.plan_name,
                           special_discount_view:discount_amount_view,
                           subtotal:total, 
                           subtotal_view:subtotal_view,
                           total:discounted_total,  
                           total_view:discounted_total_view,  
                           totalpayable:discounted_total});

            }


          if(keyselected=='bwmwc'){

            let pk = [];
            pk.push(bewisemagic, bewisemagicaddon, wiseconnect);

            let total = bewisemagic.plan_total_price+wiseconnect.plan_total_price+bewisemagicaddon.plan_total_price;
            let discount_amount = total*this.state.special_discount;
            var discount_amount_view = new Intl.NumberFormat('en-IN', {
              style: 'currency',
              currency: 'INR'
            }).format(discount_amount);

            let discounted_total = total-(discount_amount);

            var discounted_total_view = new Intl.NumberFormat('en-IN', {
              style: 'currency',
              currency: 'INR'
            }).format(discounted_total);

            var subtotal_view = new Intl.NumberFormat('en-IN', {
              style: 'currency',
              currency: 'INR'
            }).format(total);

            this.setState({order_id:this.state.addonlist[0].order_id, 
                           package_list:pk, 
                           plan_name: bewisemagic.plan_name +"+"+bewisemagicaddon.plan_name+"+"+wiseconnect.plan_name,
                           special_discount_view:discount_amount_view,
                           subtotal:total, 
                           subtotal_view:subtotal_view,
                           total:discounted_total,  
                           total_view:discounted_total_view,  
                           totalpayable:discounted_total});

          }


          if(keyselected=='bwm'){
            let pk = [];
            pk.push(bewisemagic);
            pk.push(bewisemagicaddon);

            let total = bewisemagic.plan_total_price+bewisemagicaddon.plan_total_price;
            let discount_amount = total*this.state.special_discount;
            
            var discount_amount_view = new Intl.NumberFormat('en-IN', {
              style: 'currency',
              currency: 'INR'
            }).format(discount_amount);

            let discounted_total = total-(discount_amount);

            var discounted_total_view = new Intl.NumberFormat('en-IN', {
              style: 'currency',
              currency: 'INR'
            }).format(discounted_total);

            var subtotal_view = new Intl.NumberFormat('en-IN', {
              style: 'currency',
              currency: 'INR'
            }).format(total);

            this.setState({order_id:this.state.addonlist[0].order_id, 
                           package_list:pk, 
                           plan_name: bewisemagic.plan_name +"+"+bewisemagicaddon.plan_name,
                           special_discount_view:discount_amount_view,
                           subtotal:total, 
                           subtotal_view:subtotal_view,
                           total:discounted_total,  
                           total_view:discounted_total_view,  
                           totalpayable:discounted_total});
              /*
            this.setState({order_id:this.state.addonlist[0].order_id, package_list:pk, 
                            subtotal:(bewisemagic.plan_total_price+bewisemagicaddon.plan_total_price), 
                            total:(bewisemagic.plan_total_price+bewisemagicaddon.plan_total_price), 
                            totalpayable:(bewisemagic.plan_total_price+bewisemagicaddon.plan_total_price)});
                            */
          }


        }
        else{

          if(keyselected=='bwm'){
            let pk = [];
            pk.push(bewisemagic);

            let total = bewisemagic.plan_total_price;
            let discount_amount = total*this.state.special_discount;
            
            var discount_amount_view = new Intl.NumberFormat('en-IN', {
              style: 'currency',
              currency: 'INR'
            }).format(discount_amount);

            let discounted_total = total-(discount_amount);

            var discounted_total_view = new Intl.NumberFormat('en-IN', {
              style: 'currency',
              currency: 'INR'
            }).format(discounted_total);

            var subtotal_view = new Intl.NumberFormat('en-IN', {
              style: 'currency',
              currency: 'INR'
            }).format(total);

            this.setState({package_list:pk, 
                          plan_name: bewisemagic.plan_name,
                           special_discount_view:discount_amount_view,
                           subtotal:total, 
                           subtotal_view:subtotal_view,
                           total:discounted_total,  
                           total_view:discounted_total_view,  
                           totalpayable:discounted_total});


            //this.setState({package_list:pk, subtotal:(bewisemagic.plan_total_price), total:(bewisemagic.plan_total_price), totalpayable:(bewisemagic.plan_total_price)});
          }

          if(keyselected=='bwvwc'){
            let pk = [];
            pk.push(bewisevalue, wiseconnect);
            this.setState({package_list:pk,plan_name: bewisevalue.plan_name +"+"+wiseconnect.plan_name, total: (bewisevalue.plan_total_price+wiseconnect.plan_total_price), subtotal:(bewisevalue.plan_total_price+wiseconnect.plan_total_price), totalpayable:(bewisevalue.plan_total_price+wiseconnect.plan_total_price)});
          }

          if(keyselected=='bwv'){
            let pk = [];
            pk.push(bewisevalue);

            let total = bewisevalue.plan_total_price;
            let discount_amount = total*this.state.special_discount;
            
            var discount_amount_view = new Intl.NumberFormat('en-IN', {
              style: 'currency',
              currency: 'INR'
            }).format(discount_amount);

            let discounted_total = total-(discount_amount);

            var discounted_total_view = new Intl.NumberFormat('en-IN', {
              style: 'currency',
              currency: 'INR'
            }).format(discounted_total);

            var subtotal_view = new Intl.NumberFormat('en-IN', {
              style: 'currency',
              currency: 'INR'
            }).format(total);

            this.setState({package_list:pk,
                           plan_name: bewisevalue.plan_name, 
                           special_discount_view:discount_amount_view,
                           subtotal:total, 
                           subtotal_view:subtotal_view,
                           total:discounted_total,  
                           total_view:discounted_total_view,  
                           totalpayable:discounted_total});

            //this.setState({package_list:pk, subtotal:(bewisevalue.plan_total_price), total:(bewisevalue.plan_total_price), totalpayable:(bewisevalue.plan_total_price)});
          }
        }
       
        
        /*
        if(keyselected=='bewisemagicaddon'){
          pk.push(bewisemagicaddon);
          this.setState({order_id:this.state.addonlist[0].order_id, package_list:pk, subtotal:(bewisemagicaddon.plan_total_price), total:(bewisemagicaddon.plan_total_price), totalpayable:(bewisemagicaddon.plan_total_price)});
        }

        if(keyselected=='bewisevalueaddon'){
          pk.push(bewisevalueaddon);
          this.setState({order_id:this.state.addonlist[0].order_id,package_list:pk, subtotal:(bewisevalueaddon.plan_total_price), total:(bewisevalueaddon.plan_total_price), totalpayable:(bewisevalueaddon.plan_total_price)});
        }
        */

  }


  handleChange = (e) => {
    const propName = e.target.name;
    const propValue = e.target.value;
    this.setState({
      [propName]: propValue
    })
  }

  render() {
    const { package_list, planname, subscriptionList, addonlist, paymentresponse} = this.state;

     console.log("list", addonlist);

    this.validator.purgeFields();
    return (
      <React.Fragment>
        <div class="box-shadow-custom">
          <div className='row'>
             
            <div class="col-md-12">
                    {this.state.paymentsuccess &&
                    
                    <div class="success_section">
                        <h1>Payment Successful</h1>
                        <p>Thank you for your payment! Your payment has been processed successfully.</p>
                        <p>Payment ID: <b>{paymentresponse.razorpay_payment_id}</b></p>
                        <p>You can now access your purchase immediately.</p>
                        <p>If you have any questions, please do not hesitate to contact us.</p>
                    </div>
                  
                    
                    }
                    
                    {this.state.upgraded==1 &&
                    
                      <div class="planupgradeblockwhite">

                              <div class="planlist_title">Subscribed Plan and Packages</div>

                              <div class="planlist desktoponly">

                              <table className='table table-responsive tablefullwidth'>

                                  <tr>
                                      <th width="30%">Plan</th>
                                      <th>Start Date</th>
                                      <th>Expires on</th>
                                      <th>Day(s) Left</th>
                                  </tr>

                              {subscriptionList.map((item, index)=>{

                                const diffTime = Math.abs(new Date(item.plan_end_date) - new Date(item.plan_start_date));
                                const daysLeft = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                                 
                                return  <tr>
                                          <td>{item.plan_name}</td>   
                                          <td>{item.plan_start_date}</td>
                                          <td>{item.plan_end_date}</td>
                                          <td>{daysLeft} day(s) to renewal</td>
                                        </tr>

                                })  
                              }

                              </table>

                              </div>


                              <div class="planlist mobileonly">

                              <div className='tablefullwidth'>
 

                              {subscriptionList.map((item, index)=>{

                                const diffTime = Math.abs(new Date(item.plan_end_date) - new Date(item.plan_start_date));
                                const daysLeft = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                               
                                return  <ul>
                                          <li>Plan   : {item.plan_name}</li>   
                                          <li>Start Date :{item.plan_start_date}</li>
                                          <li>Expires on :{item.plan_end_date}</li>
                                          <li>Day(s) Left : {daysLeft} day(s) to renewal</li>
                                        </ul>

                                })  
                              }

                              </div>

                              </div>

                               

                      </div>

                    }



                    {!this.state.paymentsuccess && this.state.upgraded==0 &&
                    <div class="planupgradeblock">
                    <div class="currentPlab">
                          You are currently subscribed under <span class="planname">BeWise Standard</span> ( <span class="planpoplink" onClick={this.openPopupPlanStandard}>click to view plan detail</span> ) as current plan. Upgrade to the other premium plans to obtain more features and benefits.
                    </div>

                    <div class="blocktitle">Upgrade</div>
                    <div class="blocknotes">BeWise Offers below plans for upgrade, Please choose a plan given in the dropdown</div>
                   
                    <div class="upgradeForm">


                            <div class="chooseitem">

                                    {this.state.auth_data.user_type==1 &&   
                                    <select name="upgradeplan" class="form-control upgradeplan" onChange={this.executeUpgradeList}>
                                            <option value="">Select a Plan</option>
                                            <option value="bwm">BeWise Magic</option>
                                            <option value="bwmwc">BeWise Magic + WiseConnect</option>
                                            <option value="wconly">WiseConnect Only</option>
                                    </select>
                                    }

                                    {this.state.auth_data.user_type!=1 &&   
                                    <select name="upgradeplan" class="form-control upgradeplan" onChange={this.executeUpgradeList}>
                                    <option value="">Select a Plan</option>
                                    <option value="bwv">BeWise Value</option>
                                    <option value="bwvwc">BeWise Value + WiseConnect</option>
                                    <option value="wconly">WiseConnect Only</option>
                                    </select>
                                      }

                                    <br/>
                                    {this.state.planselected &&
                                    <div class="itemcart">

                                            <div class="planlist mobileonly">


                                            {package_list.map((item, index)=>{

                                              return  <ul>
                                                        <li>{item.plan_name} <br/><span class="smldesc">{item.plan_sdesc}</span></li>   
                                                        <li class="textlink" onClick={()=>this.openPlanPop(item.plan_modal)}>Click Here</li>   
                                                        <li>{item.plan_duration} {item.plan_duration_period}</li>
                                                        <li>Rs.{item.plan_final_price}</li>
                                                        {planname=='bwvwc' && <li>Rs.{item.plan_discount}</li>}
                                                        <li style={{textAlign:"right"}}>Rs.{item.plan_total_price}</li>
                                                      </ul>

                                              })  

                                              }

                                            </div>

                                            <table className='table table-responsive tablefullwidth desktoponly'>

                                                <tr>
                                                    <th width="30%">Plan</th>
                                                    <th >Plan Detail</th>
                                                    <th >Period</th>
                                                    <th >Cost</th>
                                                    {planname=='bwvwc' &&
                                                    <th >Discount (Amount)</th>
                                                    }
                                                    <th style={{textAlign:"right"}}>Price</th>
                                                </tr>
                                                {package_list.map((item, index)=>{

                                                    return  <tr>
                                                              <td>{item.plan_name} <br/><span class="smldesc">{item.plan_sdesc}</span></td>   
                                                              <td class="textlink" onClick={()=>this.openPlanPop(item.plan_modal)}>Click Here</td>   
                                                              <td>{item.plan_duration} {item.plan_duration_period}</td>
                                                              <td>Rs.{item.plan_final_price}</td>
                                                              {planname=='bwvwc' && <td>Rs.{item.plan_discount}</td>}
                                                              <td style={{textAlign:"right"}}>Rs.{item.plan_total_price}</td>
                                                            </tr>

                                                })  
                                               
                                                }


                                            </table>

                                            <div class="floatrightbillbox">

                                                <div class="billbox">  
                                                  <div class="bill_line_flex">
                                                      <div class="billlabel">Sub Total</div>
                                                      <div class="billrate">{this.state.subtotal_view}</div>
                                                  </div>
                                                  <div class="bill_line_flex">
                                                      <div class="billlabel">Special Discount</div>
                                                      <div class="billrate">{this.state.special_discount_view}</div>
                                                  </div>

                                                  <div class="bill_line_flex">
                                                      <div class="billlabel">Total</div>
                                                      <div class="billrate">{this.state.total_view}</div>
                                                  </div>

                                                  <div class="bill_confirm">
                                                  <button type='submit' className="btn btn-primary btn-sm"
                                                      onClick={this.displayRazorpay}>Confirm and Subscribe</button>
                                                  </div>
                                                </div>

                                            </div>
                                    </div>
                                    }
                            </div>

                    </div>
                    {this.state.auth_data.user_type!=2 &&                                          
                    <div>
                        <br/><br/>
                        <div class="wscoffer">If you have received Code for WiseConnect, Please enter here</div><br/>
                        <div><input type="text" name="code" id="wccode" class="wscofferinputs" onChange={this.handleChange} /> &nbsp;<button class="btn btn-primary" onClick={this.subscribeTrail}>Submit</button> </div>

                        <div class="resultmessage">
                            {this.state.wc_error &&
                              <div class="error15">{this.state.wc_error_message}</div>
                            }
                             {this.state.wc_success &&
                              <div class="success15">{this.state.wc_success_message}</div>
                            }
                        </div>
                    </div>
                    }
                   
                    </div>

                  }
            </div>
          </div>
        </div>

        <Modal size="lg" isOpen={this.state.openPopupAddOn} className="modalpopup">
          <ModalHeader>BeWise Value Addon Branch</ModalHeader>
          <ModalBody className='p-0 detailedpreview'>
          <div class="planbox" style={{margin:"60px"}}>

                 Applicable to BeWise Value
              
          </div>

          </ModalBody>
          <ModalFooter>
            <div className='row'>
              <div className='col-md-12 text-center'>
                <button className='btn btn-sm btn-default' onClick={this.cancelPopAddon}>Close</button>
              </div>
            </div>

          </ModalFooter>
        </Modal>


        { /* plan standard */}
        <Modal size="lg" isOpen={this.state.openPopupPlanStandard} className="modalpopup">
          <ModalHeader>BeWise Standard</ModalHeader>
          <ModalBody className='p-0 detailedpreview'>
          <div class="planbox" style={{margin:"60px"}}>

              <table class="pricing-table-box">
                <tbody>
                    <tr>
                        <td width="40%" class="pricing-table-box-text">
                            <h2>PRICING PLANS</h2>
                        </td>
                        <td width="15%">
                            <div class="pricing-table-box-item">
                                <div class="pricing-table-box-item-head color2">
                                    <p>BeWise Standard</p>
                                </div>
                                <div class="pricing-table-box-item-price color2">
                                    <p><span>FREE</span></p>
                                </div>
                            </div>
                        </td>
                        
                        
                    </tr>

                    <tr class="pricing-table-box-list">
                        <td class="first-row bolder">24x 7 visibility and growth. Build trust with target audience</td>
                        <td class="second-row"><span class="fa fa-check"></span></td>
                      
                        
                    </tr>


                    <tr class="pricing-table-box-list">
                        <td class="first-row">&nbsp;&nbsp;&nbsp;&nbsp;Professional & continious digital presence</td>
                        <td class="second-row"><span class="fa fa-check"></span></td>
                        
                        
                    </tr>
                    
                        <tr class="pricing-table-box-list">
                        <td class="first-row">&nbsp;&nbsp;&nbsp;&nbsp;Continious visibility reviews & ratings to enable growth</td>
                        <td class="second-row"><span class="fa fa-check"></span></td>
                      
                        
                    </tr>
                        <tr class="pricing-table-box-list">
                        <td class="first-row">&nbsp;&nbsp;&nbsp;&nbsp;Upload Pictures & Videos</td>
                        <td class="second-row">3 Free</td>
                        
                        
                    </tr>
                        <tr class="pricing-table-box-list">
                        <td class="first-row">&nbsp;&nbsp;&nbsp;&nbsp;Direct email & message interaction for parent enqruires/ Feedback</td>
                        <td class="second-row"><span class="fa fa-times"></span></td>
                      
                        
                    </tr> 
                        <tr class="pricing-table-box-list">
                        <td class="first-row">&nbsp;&nbsp;&nbsp;&nbsp;Featured in Trending Now.</td>
                        <td class="second-row"><span class="fa fa-times"></span></td>
                        
                        
                    </tr>
                        <tr class="pricing-table-box-list">
                        <td class="first-row">&nbsp;&nbsp;&nbsp;&nbsp;Collaborative social media supportives - as and when</td>
                        <td class="second-row"><span class="fa fa-times"></span></td>
                      
                        
                    </tr>
                        <tr class="pricing-table-box-list">
                        <td class="first-row">&nbsp;&nbsp;&nbsp;&nbsp;Verified & Supported partner stamp </td>
                        <td class="second-row"><span class="fa fa-times"></span></td>
                        
                        
                    </tr>

                    <tr class="pricing-table-box-list">
                        <td class="first-row">&nbsp;&nbsp;&nbsp;&nbsp;Post your ad in your School landing page</td>
                        <td class="second-row"><span class="fa fa-times"></span></td>
                      
                        
                    </tr>

                  
                    <tr class="pricing-table-box-list">
                        <td class="first-row bolder">Immediate updates for Leads /enquiries @ BeWise platform</td>
                        <td class="second-row"><span class="fa fa-times"></span></td>
                        
                        
                    </tr>

                        <tr class="pricing-table-box-list">
                        <td class="first-row bolder">Benchmark your organisation with your choice of peers / competitors</td>
                        <td class="second-row"><span class="fa fa-times"></span></td>
                        
                        
                    </tr>

                        <tr class="pricing-table-box-list">
                        <td class="first-row bolder">Build thought leadership and enhance your brand value.</td>
                        <td class="second-row"><span class="fa fa-times"></span></td>
                        
                        
                    </tr>

                        <tr class="pricing-table-box-list">
                        <td class="first-row bolder">Ads & newsletter promotion @ special prices</td>
                        <td class="second-row"><span class="fa fa-times"></span></td>
                        
                        
                    </tr>

                        <tr class="pricing-table-box-list">
                        <td class="first-row bolder">Free benefits upto INR 50K + for you & your customers</td>
                        <td class="second-row"><span class="fa fa-times"></span></td>
                        
                    </tr>

                        <tr class="pricing-table-box-list">
                        <td class="first-row bolder">Scope for collaborative & customised services to drive growth</td>
                        <td class="second-row"><span class="fa fa-times"></span></td>
                        
                        
                    </tr>

                        <tr class="pricing-table-box-list">
                        <td class="first-row bolder">Multiple benefits @ WiseConnect, our Talent Management support.</td>
                        <td class="second-row"><span class="fa fa-times"></span></td>
                        
                        
                    </tr>

                        <tr class="pricing-table-box-list">
                        <td class="first-row bolder">You get data & analytics to help / accelerate growth</td>
                        <td class="second-row">Partly Free</td>
                        
                        
                    </tr>

                        <tr class="pricing-table-box-list">
                        <td class="first-row bolder">Easy access to Skill building and self-development for all in team</td>
                        <td class="second-row">Partly Free</td>
                        
                    </tr>

                  
                  
                </tbody>
              </table>
          </div>

          </ModalBody>
          <ModalFooter>
            <div className='row'>
              <div className='col-md-12 text-center'>
                <button className='btn btn-sm btn-default' onClick={this.cancelPop1}>Close</button>
              </div>
            </div>

          </ModalFooter>
        </Modal>

        { /* plan BeWise Value */}            
        <Modal size="lg" isOpen={this.state.openPopupPlanBv} className="modalpopup">
          <ModalHeader>BeWise Value</ModalHeader>
          <ModalBody className='p-0 detailedpreview'>
          <div class="planbox" style={{margin:"60px"}}>

          <table class="pricing-table-box">
  <tbody>
      <tr>
          <td width="40%" class="pricing-table-box-text">
              <h2>PRICING PLANS</h2>
          </td>
          
          <td width="15%">
              <div class="pricing-table-box-item">
                  <div class="pricing-table-box-item-head bewisemagic">
                      <p>BeWise Value</p>

                  </div>
                  <div class="pricing-table-box-item-price color2">
                      <p><span>Annual Subscription Fee</span></p>

                  </div>

              </div>
          </td>
           
      </tr>

      <tr class="pricing-table-box-list">
          <td class="first-row bolder">24x 7 visibility and growth. Build trust with target audience</td>
          <td class="third-row"><span class="fa fa-check"></span></td>
          
      </tr>


      <tr class="pricing-table-box-list">
          <td class="first-row">&nbsp;&nbsp;&nbsp;&nbsp;Professional & continious digital presence</td>
          <td class="third-row"><span class="fa fa-check"></span></td>
          
      </tr>
      
          <tr class="pricing-table-box-list">
          <td class="first-row">&nbsp;&nbsp;&nbsp;&nbsp;Continious visibility reviews & ratings to enable growth</td>
          <td class="third-row"><span class="fa fa-check"></span></td>
          
      </tr>
          <tr class="pricing-table-box-list">
          <td class="first-row">&nbsp;&nbsp;&nbsp;&nbsp;Upload Pictures & Videos</td>
          <td class="third-row">Upto 15</td>
          
      </tr>
          <tr class="pricing-table-box-list">
          <td class="first-row">&nbsp;&nbsp;&nbsp;&nbsp;Direct email & message interaction for parent enqruires/ Feedback</td>
          <td class="third-row"><span class="fa fa-check"></span></td>
          
      </tr> 
          <tr class="pricing-table-box-list">
          <td class="first-row">&nbsp;&nbsp;&nbsp;&nbsp;Featured in Trending Now.</td>
          <td class="third-row"><span class="fa fa-check"></span></td>
          
      </tr>
          <tr class="pricing-table-box-list">
          <td class="first-row">&nbsp;&nbsp;&nbsp;&nbsp;Collaborative social media supportives - as and when</td>
          <td class="third-row"><span class="fa fa-check"></span></td>
          
      </tr>
          <tr class="pricing-table-box-list">
          <td class="first-row">&nbsp;&nbsp;&nbsp;&nbsp;Verified & Supported partner stamp </td>
          <td class="third-row"><span class="fa fa-check"></span></td>
          
      </tr>

      <tr class="pricing-table-box-list">
          <td class="first-row">&nbsp;&nbsp;&nbsp;&nbsp;Post your ad in your School landing page</td>
          <td class="third-row"><span class="fa fa-check"></span></td>
          
      </tr>

     
      <tr class="pricing-table-box-list">
          <td class="first-row bolder">Immediate updates for Leads /enquiries @ BeWise platform</td>
          <td class="third-row"><span class="fa fa-check"></span></td>
          
      </tr>

          <tr class="pricing-table-box-list">
          <td class="first-row bolder">Benchmark your organisation with your choice of peers / competitors</td>
          <td class="third-row"><span class="fa fa-check"></span></td>
          
      </tr>

          <tr class="pricing-table-box-list">
          <td class="first-row bolder">Build thought leadership and enhance your brand value.</td>
          <td class="third-row"><span class="fa fa-check"></span></td>
          
      </tr>

          <tr class="pricing-table-box-list">
          <td class="first-row bolder">Ads & newsletter promotion @ special prices</td>
          <td class="third-row"><span class="fa fa-check"></span></td>
          
      </tr>

          <tr class="pricing-table-box-list">
          <td class="first-row bolder">Free benefits upto INR 50K + for you & your customers</td>
          <td class="third-row"><span class="fa fa-check"></span></td>
          
      </tr>

          <tr class="pricing-table-box-list">
          <td class="first-row bolder">Scope for collaborative & customised services to drive growth</td>
          <td class="third-row"><span class="fa fa-check"></span></td>
          
      </tr>

          <tr class="pricing-table-box-list">
          <td class="first-row bolder">Multiple benefits @ WiseConnect, our Talent Management support.</td>
          <td class="third-row"><span class="fa fa-check"></span></td>
          
      </tr>

          <tr class="pricing-table-box-list">
          <td class="first-row bolder">You get data & analytics to help / accelerate growth</td>
          <td class="third-row"><span class="fa fa-check"></span></td>
          
      </tr>

          <tr class="pricing-table-box-list">
          <td class="first-row bolder">Easy access to Skill building and self-development for all in team</td>
          <td class="third-row"><span class="fa fa-check"></span></td>
          
      </tr>

     
      
  </tbody>
</table>
      

              
          </div>

          </ModalBody>
          <ModalFooter>
            <div className='row'>
              <div className='col-md-12 text-center'>
                <button className='btn btn-sm btn-default' onClick={this.cancelPopBv}>Close</button>
              </div>
            </div>

          </ModalFooter>
        </Modal>

        { /* plan WiseConnect + BeWise */}            
        <Modal size="lg" isOpen={this.state.openPopupPlanWc} className="modalpopup">
          <ModalHeader>WiseConnect</ModalHeader>
          <ModalBody className='p-0 detailedpreview'>
          <div class="planbox" style={{margin:"60px"}}>

          <table class="pricing-table-box">
                <tbody>
                    <tr>
                        <td width="40%" class="pricing-table-box-text">
                            <h2>All Institutions</h2>
                        </td>
                        <td width="15%">
                            <div class="pricing-table-box-item">
                                <div class="pricing-table-box-item-head color2">
                                    <p>WiseConnect + BeWise</p>
                                </div>
                                
                            </div>
                        </td>
                        
                        
                    </tr>

                    <tr class="pricing-table-box-list">
                        <td class="first-row">Initial Sign Up</td>
                        <td class="second-row">Free</td>
                         
                        
                    </tr>
                    
                        <tr class="pricing-table-box-list">
                        <td class="first-row">All benefits @ BeWise to enable growth</td>
                        <td class="second-row">Yes</td>
                        
                        
                    </tr>
                        <tr class="pricing-table-box-list">
                        <td class="first-row">Instant Talent Search @ Portal & reach candidates</td>
                        <td class="second-row">Yes</td>
                        
                        
                    </tr>

                    
                    <tr class="pricing-table-box-list">
                        <td class="first-row">Post Jobs & receive applications @ Portal</td>
                        <td class="second-row">Yes</td>
                         
                        
                    </tr>


                    <tr class="pricing-table-box-list">
                        <td class="first-row">Full access to Courses / Products / articles @ Portal</td>
                        <td class="second-row">Yes</td>
                        
                        
                    </tr>


                    <tr class="pricing-table-box-list">
                        <td class="first-row">Complete access to curated benefits from Partners</td>
                        <td class="second-row">Yes</td>
                        
                        
                    </tr>


                    <tr class="pricing-table-box-list">
                        <td class="first-row">Available data analytics, reports & benchmarks.</td>
                        <td class="second-row">Yes</td>
                         
                        
                    </tr>


                    <tr class="pricing-table-box-list">
                        <td class="first-row">Downloading of candidate CV** @ WiseConnect</td>
                        <td class="second-row">Yes</td>
                        
                        
                    </tr> 


                    <tr class="pricing-table-box-list">
                        <td class="first-row">Private & direct interaction with candidates / applications</td>
                        <td class="second-row">Yes</td>
                         
                        
                    </tr>

                    <tr class="pricing-table-box-list">
                        <td class="first-row">Ads & newsletter promotion on WiseConnect @ special prices</td>
                        <td class="second-row">Yes</td>
                        
                        
                    </tr>

                    <tr class="pricing-table-box-list">
                        <td class="first-row">Advisory services in WiseConnect @ special prices</td>
                        <td class="second-row">Yes</td>
                        
                        
                    </tr>
                    
                    <tr class="pricing-table-box-list">
                        <td class="first-row">Launch special - No additional or retainer fee on hiring @ WiseConnect</td>
                        <td class="second-row">Yes</td>
                        
                    </tr>

                    <tr><td colspan3>&nbsp;</td></tr>


                    <tr class="pricing-table-box-list">
                        <td class="first-row">Pricing ***  (WiseConnect only and Inclusive of all applicable taxes)</td>
                        <td class="second-row" id="showPrice1"><button class="btn btn-primary btn-sm" onClick={this.showPrice1}>View Pricing</button></td>
                        
                        
                    </tr>

                    <tr class="pricing-table-box-list">
                        <td class="first-row">&nbsp;</td>
                        <td class="second-row">Billed Annually</td>
                        
                        
                    </tr>

                    <tr class="pricing-table-box-list">
                        <td class="first-row">&nbsp;</td>
                        <td class="second-row">3 Months Free with 1st subscription</td>
                         
                        
                    </tr>
                                      
                   
                </tbody>
              </table>       
               
          </div>

          </ModalBody>
          <ModalFooter>
            <div className='row'>
              <div className='col-md-12 text-center'>
                <button className='btn btn-sm btn-default' onClick={this.cancelPopWc}>Close</button>
              </div>
            </div>

          </ModalFooter>
        </Modal>

        { /* plan WiseConnect Exclusive */}                    
        <Modal size="lg" isOpen={this.state.openPopupPlanWcExcl} className="modalpopup">
          <ModalHeader>WiseConnect Exclusive</ModalHeader>
          <ModalBody className='p-0 detailedpreview'>
          <div class="planbox" style={{margin:"60px"}}>

          <table class="pricing-table-box">
                <tbody>
                    <tr>
                        <td width="40%" class="pricing-table-box-text">
                            <h2>All Institutions</h2>
                        </td>
                       
                        <td width="15%">
                            <div class="pricing-table-box-item">
                                <div class="pricing-table-box-item-head bewisemagic">
                                    <p>WiseConnect Exclusive</p>

                                </div>
                                

                            </div>
                        </td>
                        
                    </tr>

                    <tr class="pricing-table-box-list">
                        <td class="first-row">Initial Sign Up</td>
                         
                        <td class="third-row">Free - Restricted access*</td>
                        
                    </tr>
                    
                        <tr class="pricing-table-box-list">
                        <td class="first-row">All benefits @ BeWise to enable growth</td>
                         
                        <td class="third-row">NA</td>
                        
                    </tr>
                        <tr class="pricing-table-box-list">
                        <td class="first-row">Instant Talent Search @ Portal & reach candidates</td>
                        
                        <td class="third-row">Yes</td>
                        
                    </tr>

                    
                    <tr class="pricing-table-box-list">
                        <td class="first-row">Post Jobs & receive applications @ Portal</td>
                         
                        <td class="third-row">Yes</td>
                        
                    </tr>


                    <tr class="pricing-table-box-list">
                        <td class="first-row">Full access to Courses / Products / articles @ Portal</td>
                        
                        <td class="third-row">Yes</td>
                        
                    </tr>


                    <tr class="pricing-table-box-list">
                        <td class="first-row">Complete access to curated benefits from Partners</td>
                         
                        <td class="third-row">Yes</td>
                        
                    </tr>


                    <tr class="pricing-table-box-list">
                        <td class="first-row">Available data analytics, reports & benchmarks.</td>
                        
                        <td class="third-row">Yes</td>
                        
                    </tr>


                    <tr class="pricing-table-box-list">
                        <td class="first-row">Downloading of candidate CV** @ WiseConnect</td>
                        
                        <td class="third-row">Yes</td>
                        
                    </tr> 


                    <tr class="pricing-table-box-list">
                        <td class="first-row">Private & direct interaction with candidates / applications</td>
                        
                        <td class="third-row">Yes</td>
                        
                    </tr>

                    <tr class="pricing-table-box-list">
                        <td class="first-row">Ads & newsletter promotion on WiseConnect @ special prices</td>
                        
                        <td class="third-row">Yes</td>
                        
                    </tr>

                    <tr class="pricing-table-box-list">
                        <td class="first-row">Advisory services in WiseConnect @ special prices</td>
                         
                        <td class="third-row">Yes</td>
                        
                    </tr>
                    
                    <tr class="pricing-table-box-list">
                        <td class="first-row">Launch special - No additional or retainer fee on hiring @ WiseConnect</td>
                        
                        <td class="third-row">Yes</td>
                    </tr>

                    <tr><td colspan3>&nbsp;</td></tr>


                    <tr class="pricing-table-box-list">
                        <td class="first-row">Pricing ***  (WiseConnect only and Inclusive of all applicable taxes)</td>
                         
                        <td class="third-row" id="showPrice2"><button class="btn btn-primary btn-sm" onClick={this.showPrice2}>View Pricing</button></td>
                        
                    </tr>

                    <tr class="pricing-table-box-list">
                        <td class="first-row">&nbsp;</td>
                        
                        <td class="third-row">Billed Half yearly</td>
                        
                    </tr>

                    <tr class="pricing-table-box-list">
                        <td class="first-row">&nbsp;</td>
                         
                        <td class="third-row">NIL</td>
                        
                    </tr>
                                      
                   
                </tbody>
              </table>       
               
          </div>

          </ModalBody>
          <ModalFooter>
            <div className='row'>
              <div className='col-md-12 text-center'>
                <button className='btn btn-sm btn-default' onClick={this.cancelPopWcExcl}>Close</button>
              </div>
            </div>

          </ModalFooter>
        </Modal>
         
      </React.Fragment >
    );

  }
  displayRazorpay = async (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      const res = await this.loadScript(
        "https://checkout.razorpay.com/v1/checkout.js"
      );
      if (!res) {
        alert("Razorpay SDK failed to load. Are you online?");
        return;
      }
      let ins = JSON.stringify({
        amount: this.state.totalpayable
      });
      CreatePay(ins).then((res) => {
        this.setState({
          amount: res.amount,
          order_id: res.id,
          currency: res.currency,
        });
        this.payinfo();
      });
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  }
  payinfo() {
    var This = this;
    var payment_data;
    const options = {
      key: RAZORPAY_TEST, // Enter the Key ID generated from the Dashboard
      amount: this.state.amount.toString(),
      currency: this.state.currency,
      name: this.state.partner_name,
      description: "Plan Upgrade - Partner Program",
      // image: { logo },
      // order_id: this.state.order_id,
      handler: async function (response) {
        console.log('response', response);
        This.handlePaySubmit(response);
        payment_data = response.razorpay_payment_id;
        const data = {
          // orderCreationId: this.state.order_id,
          razorpayPaymentId: response.razorpay_payment_id,
          razorpayOrderId: response.razorpay_order_id,
          razorpaySignature: response.razorpay_signature,
        };
        //  const result = await axios.post("/payment/success", data);
      },
      prefill: {
        name: this.state.partner_name,
        email: this.state.partner_email,
      },
      notes: {
        address: this.state.partner_address,
      },
      theme: {
        color: "#61dafb",
      },
    };
    const paymentObject = new window.Razorpay(options);
    paymentObject.open();

  }

  loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }


  // handlePaySubmit = () => {
  handlePaySubmit = (response) => {
    let razorpay_payment_id = response.razorpay_payment_id;

    if (razorpay_payment_id != '') {
      let ins = '';
      //let upgradeList = this.state.upgradeList.filter((item) => (item.is_check === true && item.nplanid != 0 && parseInt(item.period) > 0));
      let upgradeList = this.state.package_list;

      if(this.state.planname!='bewisevalueaddon' && this.state.planname!='bewisemagicaddon'){
      ins = JSON.stringify({
        razorpay_payment_id: response.razorpay_payment_id,
        razorpay_order_id: response.razorpay_payment_id,
        razorpay_signature: response.razorpay_signature,
        basesubtotal: this.state.basesubtotal,
        subtotal: this.state.subtotal,
        discount_per: this.state.discount_per,
        coupon_id: this.state.coupon_applied ? this.state.coupon_id : 0,
        discount_amount: this.state.discount_amount, coupon_per: this.state.coupon_per,
        coupon_amount: this.state.coupon_amount, sgst_per: this.state.sgst_per,
        cgst_per: this.state.cgst_per, sgst_amount: this.state.sgst_amount,
        cgst_amount: this.state.cgst_amount, totalpayable: this.state.totalpayable, totalselected: this.state.totalselected,
        chart_discount_amount: this.state.chart_discount_amount,
        chart_discount: this.state.chart_discount,
        user_type: this.state.auth_data.user_type,
        user_paytype: 1,
        upgradeList: upgradeList,
        plan:this.state.plan_name,
        upgraded_plan:this.state.planname,
        invoice_type: 2,
        login_id: this.state.auth_data.login_id,
        uid:this.state.auth_data.uid,
        order_id:this.state.order_id,
        email_id:this.state.auth_data.email_id,
        first_name: this.state.auth_data.first_name,
        last_name:this.state.auth_data.last_name,

        url: 'upgradeonly',
        role: 3
      });
       console.log('update values', JSON.parse(ins));
      // return false;

     
      partnerSubscription(ins).then((res) => {
       
        if (res.status === 1) {
           

          this.state.auth_data.is_active = 1;
          localStorage.setItem('user_data', JSON.stringify(this.state.auth_data));
          localStorage.setItem('is_active', 1);
          this.setState({paymentsuccess:true, paymentresponse:response});
         
          setTimeout(function () {
            window.location.reload();
          }, 5000);

        }
      }); 

      }else{

        ins = JSON.stringify({
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_order_id: response.razorpay_payment_id,
          razorpay_signature: response.razorpay_signature,
          basesubtotal: this.state.basesubtotal,
          subtotal: this.state.subtotal,
          discount_per: this.state.discount_per,
          coupon_id: this.state.coupon_applied ? this.state.coupon_id : 0,
          discount_amount: this.state.discount_amount, coupon_per: this.state.coupon_per,
          coupon_amount: this.state.coupon_amount, sgst_per: this.state.sgst_per,
          cgst_per: this.state.cgst_per, sgst_amount: this.state.sgst_amount,
          cgst_amount: this.state.cgst_amount, totalpayable: this.state.totalpayable, totalselected: this.state.totalselected,
          chart_discount_amount: this.state.chart_discount_amount,
          chart_discount: this.state.chart_discount,
          user_type: this.state.auth_data.user_type,
          user_paytype: 1,
          upgradeList: upgradeList,
          plan:this.state.plan_name,
          upgraded_plan:this.state.planname,
          invoice_type: 2,
          login_id: this.state.auth_data.login_id,
          uid:this.state.auth_data.uid,
          order_id:this.state.order_id,

          email_id:this.state.auth_data.email_id,
          first_name: this.state.auth_data.first_name,
          last_name:this.state.auth_data.last_name,

          url: 'upgradeonly'
        });
         console.log('update values', JSON.parse(ins));
        // return false;

       
        partnerSubscription(ins).then((res) => {
           
          if (res.status === 1) {
            
            this.state.auth_data.is_active = 1;
            localStorage.setItem('user_data', JSON.stringify(this.state.auth_data));
            localStorage.setItem('is_active', 1);
            this.setState({paymentsuccess:true, paymentresponse:response});

            setTimeout(function () {
              window.location.reload();
            }, 5000);
           
          }
        }); 

      }



    } else {
      alert("error ");
      console.log(response.error);
    }
  }


  // handlePaySubmit = () => {
    handlePaySubmitDummy = (response) => {
      let razorpay_payment_id = "XYZ00001";
      let razorpay_signature = "SIG2343434";

      if (razorpay_payment_id != '') {
        let ins = '';
        //let upgradeList = this.state.upgradeList.filter((item) => (item.is_check === true && item.nplanid != 0 && parseInt(item.period) > 0));
        let upgradeList = this.state.package_list;
        ins = JSON.stringify({
          razorpay_payment_id: razorpay_payment_id,
          razorpay_order_id: razorpay_payment_id,
          razorpay_signature: razorpay_signature,
          basesubtotal: this.state.basesubtotal,
          subtotal: this.state.subtotal,
          discount_amount: this.state.discount_amount, 
          totalpayable: this.state.totalpayable, 
          user_type: this.state.auth_data.user_type,
          user_paytype: 1,
          upgradeList: upgradeList,
          plan:this.state.plan,
          invoice_type: 2,
          login_id: this.state.auth_data.login_id,
          url: 'upgradeonly',
          role: 3
        });
        // console.log('update values', JSON.parse(ins));
        // return false;
        partnerSubscription(ins).then((res) => {
          let toastr = '';
          if (res.status === 1) {
            alert("updated");
            /*
            toastr = window.toastr.success;
            toastr('', 'Your plan has been upgraded.', {
              positionClass: "toast-bottom-right",
              containerId: "toast-bottom-right"
            });
            this.state.auth_data.is_active = 1;
            localStorage.setItem('user_data', JSON.stringify(this.state.auth_data));
            localStorage.setItem('is_active', 1);
            setTimeout(function () {
              window.location.reload();
            }, 2000);
            */
  
          } else {
            let er = res.message
            alert("not updated");
            /*
            toastr = window.toastr.error; //warning
            toastr(er, toastr, {
              positionClass: "toast-bottom-right",
              containerId: "toast-bottom-right"
            });
            */
          }
        });
      } else {
        let toastr = '';
        alert("error ");
        /*
        toastr = window.toastr.error; //warning
        toastr('', 'Failed to Pay', {
          positionClass: "toast-bottom-right",
          containerId: "toast-bottom-right"
        });
        */
      }
    }
  

}

export default UpgradeV1;


// WEBPACK FOOTER //
// ./src/components/bewise/partners/subscribe/upgradeV1.jsx